var _defs, _path, _g, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoappLogoClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 564.3 566.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#037ca3;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.74,312.61c-26.19,25.6-37.74,60-28.09,83.68,8,19.74,29.55,30.17,62.2,30.17H435.4a513.45,513.45,0,0,0,14.93-81.7H124.38l3.46-2.78c72.46-58.17,191.44-120.79,281.44-120.79,35.58,0,49.06,13.4,57.54,26.51,12.47,19.28,15.77,43.81,15.77,54.09A359.75,359.75,0,0,1,480,343.38l-.07.52a520.91,520.91,0,0,1-14.91,82.56h82.07C549.5,418,564.3,362.6,564.3,301.79c0-56.14-32.4-162.31-155-162.31-126.27,0-285.67,89.21-371.54,173.13"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.74,312.61c-26.19,25.6-37.74,60-28.09,83.68,8,19.74,29.55,30.17,62.2,30.17H435.4a513.45,513.45,0,0,0,14.93-81.7H124.38l3.46-2.78c72.46-58.17,191.44-120.79,281.44-120.79,35.58,0,49.06,13.4,57.54,26.51,12.47,19.28,15.77,43.81,15.77,54.09A359.75,359.75,0,0,1,480,343.38l-.07.52a520.91,520.91,0,0,1-14.91,82.56h82.07C549.5,418,564.3,362.6,564.3,301.79c0-56.14-32.4-162.31-155-162.31-126.27,0-285.67,89.21-371.54,173.13"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 139.49,
    width: 564.3,
    height: 286.97
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 199.48,
    width: 20.99,
    height: 8.31
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 276.03,
    y: 562.01,
    width: 9.26,
    height: 4.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoappLogoClean);
export default __webpack_public_path__ + "static/media/AutoappLogoClean.444bc49e6585203ad3ca78f4ab66ba1a.svg";
export { ForwardRef as ReactComponent };